export default __webpack_public_path__ + "components/page-header/static/icon-bike-0b1dfef42bd2730604f5e5956fa23b7b.svg";